<h1 matDialogTitle>{{ data.titulo }}</h1>

<div mat-dialog-content>
    <p [innerHTML]="data.mensaje"></p>
</div>

<div mat-dialog-actions align="end">
    <button type="button" mat-raised-button color="accent" (click)="dialogRef.close(true)" *ngIf="data.nombreAccion">
        <span>{{ data.nombreAccion  }}</span>
    </button>
    <button type="button" mat-raised-button color="accent" (click)="dialogRef.close(true)" *ngIf="!data.nombreAccion">
        <mat-icon>check</mat-icon>
        <span>  Aceptar</span>
    </button>
    <button type="button" mat-button (click)="dialogRef.close(false)" *ngIf="!data.ocultarCerrar">
        <mat-icon>close</mat-icon>
        <span>  Cancelar</span>
    </button>
</div>

<br />